import { Box, useStyleConfig } from '@chakra-ui/react'
import React from 'react'

interface ComponentProps {
  variant?: string
  children: React.ReactNode
}

export const Section = (props: ComponentProps) => {
  const { variant, ...rest } = props

  const styles = useStyleConfig('Section', { variant })

  return <Box __css={styles} {...rest} />
}
